// Общие UI-примитивы обеих страниц: экранирование, тосты, шторки.
//
// Тост свой, а не notyf с cdn.jsdelivr.net: сторонний CDN стоял в критическом
// пути оплаты и из России регулярно недоступен — витрина молча теряла сообщения
// об ошибках счёта. Нужно от него ровно всплывающее сообщение на две секунды.
import './ui.css';

export function esc(s: string): string {
  const d = document.createElement('div');
  d.textContent = s ?? '';
  return d.innerHTML;
}

/** Экранирование для подстановки в значение HTML-атрибута. */
export function attr(s: string): string {
  return esc(s).replace(/"/g, '&quot;');
}

export function $(id: string): HTMLElement | null {
  return document.getElementById(id);
}

// --- тосты -----------------------------------------------------------------

export function toast(type: 'success' | 'error', message: string): void {
  let host = $('toast-host');
  if (!host) {
    host = document.createElement('div');
    host.id = 'toast-host';
    document.body.appendChild(host);
  }
  const el = document.createElement('div');
  el.className = `toast toast--${type}`;
  el.textContent = message;
  host.appendChild(el);
  requestAnimationFrame(() => el.classList.add('toast--in'));
  setTimeout(() => {
    el.classList.remove('toast--in');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
  }, 2500);
}

// --- шторки ----------------------------------------------------------------

let openSheets = 0;

export function lockBgScroll(): void {
  if (openSheets++ === 0) {
    document.documentElement.classList.add('sheet-open');
    document.body.classList.add('sheet-open');
  }
}

export function unlockBgScroll(): void {
  openSheets = Math.max(0, openSheets - 1);
  if (openSheets === 0) {
    document.documentElement.classList.remove('sheet-open');
    document.body.classList.remove('sheet-open');
  }
}

/** Шторку можно утянуть пальцем вниз и закрыть — как в gb. */
export function makeSheetDraggable(
  dragEl: HTMLElement | null,
  closeFn: () => void,
  scrollEl: Element | null,
): void {
  if (!dragEl || dragEl.dataset.dragBound) return;
  dragEl.dataset.dragBound = '1';
  let startY = 0;
  let dy = 0;
  let dragging = false;

  // Позицию шторки в CSS мы задаём через !important (перебить !important от gb),
  // поэтому drag тоже должен писать !important-инлайн — обычный inline его не
  // перебьёт, и палец «не двигал» лист.
  const setT = (value: string): void =>
    dragEl.style.setProperty('transform', value, 'important');

  dragEl.addEventListener(
    'touchstart',
    (e) => {
      const sc = (scrollEl as HTMLElement) || dragEl;
      if (sc.scrollTop > 0) return; // сначала домотали контент до верха
      if ((e.target as HTMLElement).closest('button, input, a, textarea')) return;
      startY = e.touches[0].clientY;
      dy = 0;
      dragging = true;
      dragEl.style.setProperty('transition', 'none', 'important');
    },
    { passive: true },
  );
  dragEl.addEventListener(
    'touchmove',
    (e) => {
      if (!dragging) return;
      dy = e.touches[0].clientY - startY;
      setT(dy <= 0 ? 'translateY(0)' : `translateY(${dy}px)`);
      if (dy > 0 && e.cancelable) e.preventDefault();
    },
    { passive: false },
  );
  const end = (): void => {
    if (!dragging) return;
    dragging = false;
    // Возвращаем управление CSS: снимаем инлайн, лист сам доедет по transition.
    dragEl.style.removeProperty('transition');
    dragEl.style.removeProperty('transform');
    if (dy > 110) closeFn();
    dy = 0;
  };
  dragEl.addEventListener('touchend', end);
  dragEl.addEventListener('touchcancel', end);
}
